export interface Chapter {
  id: string;
  number: number;
  title: string;
  date: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  artist: string;
  cover: string;
  description: string;
  genres: string[];
  status: 'ongoing' | 'completed';
  rating: number;
  views: number;
  chapters: Chapter[];
  updatedAt: string;
}

export const categories = [
  { slug: 'campus', name: '校园', icon: 'ri-school-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '热血', icon: 'ri-fire-line' },
  { slug: 'mystery', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'bl', name: '耽美', icon: 'ri-star-line' },
  { slug: 'gl', name: '百合', icon: 'ri-flower-line' },
  { slug: 'urban', name: '都市', icon: 'ri-building-line' },
  { slug: 'isekai', name: '穿越', icon: 'ri-time-line' },
];

export const comics: Comic[] = [
  {
    id: '1',
    title: '星月童话',
    author: '金智恩',
    artist: '朴秀敏',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%2C%20beautiful%20couple%20under%20starry%20night%20sky%2C%20soft%20warm%20lighting%2C%20watercolor%20texture%2C%20dreamy%20atmosphere%2C%20golden%20and%20pink%20tones%2C%20elegant%20Korean%20webtoon%20art%20style%2C%20clean%20illustration%20with%20subtle%20sparkle%20effects%2C%20romantic%20mood&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '平凡的女大学生林星辰，在一次偶然的流星雨中遇到了神秘的转学生。他有着星空般深邃的眼眸，和一段不为人知的过去。当命运的红线将两人紧紧相连，一段跨越时空的浪漫故事就此展开。每周三更新，敬请期待。',
    genres: ['romance', 'fantasy', 'campus'],
    status: 'ongoing',
    rating: 9.6,
    views: 1280000,
    chapters: [
      { id: 'c1-1', number: 1, title: '流星之夜的相遇', date: '2025-03-15' },
      { id: 'c1-2', number: 2, title: '转学生的秘密', date: '2025-03-22' },
      { id: 'c1-3', number: 3, title: '星空下的约定', date: '2025-03-29' },
      { id: 'c1-4', number: 4, title: '命运的齿轮', date: '2025-04-05' },
      { id: 'c1-5', number: 5, title: '平行世界的你', date: '2025-04-12' },
      { id: 'c1-6', number: 6, title: '时间的裂缝', date: '2025-04-19' },
      { id: 'c1-7', number: 7, title: '被遗忘的约定', date: '2025-04-26' },
      { id: 'c1-8', number: 8, title: '星光重现', date: '2025-05-03' },
    ],
    updatedAt: '2025-05-03',
  },
  {
    id: '2',
    title: '剑道至尊',
    author: '李东旭',
    artist: '姜志勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comic%20cover%2C%20powerful%20swordsman%20in%20martial%20arts%20pose%2C%20dynamic%20composition%2C%20dramatic%20lighting%20with%20golden%20and%20red%20energy%20effects%2C%20ancient%20Korean%20palace%20background%2C%20epic%20fantasy%20atmosphere%2C%20detailed%20costume%20design%2C%20Korean%20webtoon%20art%20style%2C%20action%20pose%20with%20flowing%20fabric&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '少年秦风出身卑微，却拥有千年一遇的绝世根骨。在弱肉强食的修真世界里，他凭借一把残剑，踏上了逆天改命的剑道之路。斩妖除魔，登临绝顶，且看剑道至尊如何一剑开天！',
    genres: ['action', 'fantasy', 'isekai'],
    status: 'ongoing',
    rating: 9.4,
    views: 2150000,
    chapters: [
      { id: 'c2-1', number: 1, title: '废柴的觉醒', date: '2024-11-10' },
      { id: 'c2-2', number: 2, title: '残剑之力', date: '2024-11-17' },
      { id: 'c2-3', number: 3, title: '入门试炼', date: '2024-11-24' },
      { id: 'c2-4', number: 4, title: '剑意初现', date: '2024-12-01' },
      { id: 'c2-5', number: 5, title: '风云际会', date: '2024-12-08' },
      { id: 'c2-6', number: 6, title: '秘境探险', date: '2024-12-15' },
      { id: 'c2-7', number: 7, title: '宿敌之战', date: '2024-12-22' },
      { id: 'c2-8', number: 8, title: '剑道突破', date: '2024-12-29' },
      { id: 'c2-9', number: 9, title: '宗门大比', date: '2025-01-05' },
      { id: 'c2-10', number: 10, title: '天劫降临', date: '2025-01-12' },
      { id: 'c2-11', number: 11, title: '飞升之路', date: '2025-01-19' },
      { id: 'c2-12', number: 12, title: '仙界初见', date: '2025-01-26' },
    ],
    updatedAt: '2025-01-26',
  },
  {
    id: '3',
    title: '校园奇谭',
    author: '崔智友',
    artist: '尹素英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20mystery%20comic%20cover%2C%20students%20in%20school%20uniform%20with%20mysterious%20atmosphere%2C%20dark%20school%20hallway%20background%2C%20supernatural%20elements%2C%20moody%20lighting%20with%20cool%20teal%20and%20warm%20amber%20contrast%2C%20Korean%20webtoon%20art%20style%2C%20suspenseful%20composition%2C%20subtle%20ghostly%20figures%20in%20shadow&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '转学到一所百年名校的韩智浩，发现这所学校隐藏着不为人知的秘密。深夜走廊传来的脚步声、图书馆里诡异的光影、以及那个只有他能看见的少女幽灵。当真相一步步浮出水面，他才发现，自己早已深陷其中。',
    genres: ['mystery', 'campus', 'fantasy'],
    status: 'ongoing',
    rating: 9.3,
    views: 890000,
    chapters: [
      { id: 'c3-1', number: 1, title: '新学校', date: '2025-02-10' },
      { id: 'c3-2', number: 2, title: '深夜的脚步声', date: '2025-02-17' },
      { id: 'c3-3', number: 3, title: '幽灵少女', date: '2025-02-24' },
      { id: 'c3-4', number: 4, title: '图书馆的秘密', date: '2025-03-03' },
      { id: 'c3-5', number: 5, title: '失踪的学生', date: '2025-03-10' },
      { id: 'c3-6', number: 6, title: '揭开面纱', date: '2025-03-17' },
    ],
    updatedAt: '2025-03-17',
  },
  {
    id: '4',
    title: '烈焰战神',
    author: '郑宇成',
    artist: '金俊秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20epic%20action%20comic%20cover%2C%20fierce%20warrior%20surrounded%20by%20flames%2C%20intense%20battle%20scene%2C%20dramatic%20fire%20and%20smoke%20effects%2C%20dark%20volcanic%20background%2C%20muscular%20character%20design%2C%20Korean%20webtoon%20art%20style%2C%20heroic%20stance%2C%20warm%20orange%20and%20red%20color%20palette&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '战神陨落，轮回重生。曾经威震四方的烈焰战神韩烈，在最后一战中身死道消，却意外重生为一个被家族抛弃的废柴少年。带着前世的记忆和功法，他将一步步重回巅峰，让那些曾经背叛他的人付出代价！',
    genres: ['action', 'fantasy'],
    status: 'completed',
    rating: 9.7,
    views: 3560000,
    chapters: [
      { id: 'c4-1', number: 1, title: '战神陨落', date: '2024-01-05' },
      { id: 'c4-2', number: 2, title: '废柴少年', date: '2024-01-12' },
    ],
    updatedAt: '2024-12-20',
  },
  {
    id: '5',
    title: '甜蜜陷阱',
    author: '安孝珍',
    artist: '韩智慧',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sweet%20romance%20comedy%20cover%2C%20cute%20couple%20sharing%20dessert%20in%20cozy%20cafe%2C%20warm%20pastel%20color%20palette%20with%20pink%20and%20cream%20tones%2C%20soft%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20playful%20atmosphere%2C%20floating%20heart%20and%20dessert%20illustrations%2C%20modern%20urban%20setting&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '甜品店老板的女儿苏糖糖，误打误撞成为了顶级甜品连锁集团的实习生。没想到顶头上司竟是高中时暗恋过的学长。一个是甜品天才，一个是商业精英，甜蜜又搞笑的职场恋爱喜剧即将上演！',
    genres: ['romance', 'comedy', 'urban'],
    status: 'ongoing',
    rating: 9.2,
    views: 780000,
    chapters: [
      { id: 'c5-1', number: 1, title: '甜品店小公主', date: '2025-04-01' },
      { id: 'c5-2', number: 2, title: '面试乌龙', date: '2025-04-08' },
      { id: 'c5-3', number: 3, title: '重逢的学长', date: '2025-04-15' },
      { id: 'c5-4', number: 4, title: '甜蜜对决', date: '2025-04-22' },
      { id: 'c5-5', number: 5, title: '厨房里的心跳', date: '2025-04-29' },
      { id: 'c5-6', number: 6, title: '告白奶油蛋糕', date: '2025-05-06' },
    ],
    updatedAt: '2025-05-06',
  },
  {
    id: '6',
    title: '异界药神',
    author: '朴泰俊',
    artist: '宋民浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20isekai%20comic%20cover%2C%20young%20alchemist%20holding%20glowing%20potion%20in%20magical%20laboratory%2C%20fantasy%20world%20background%20with%20floating%20herbs%20and%20magic%20circles%2C%20warm%20emerald%20and%20gold%20color%20palette%2C%20Korean%20webtoon%20art%20style%2C%20mystical%20atmosphere%2C%20detailed%20potion%20bottles%20and%20alchemy%20tools&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '三流药剂师林逸在实验中意外身亡，灵魂穿越到一个以炼药为尊的异世界。凭借现代医学知识和化学功底，他从最底层开始，一步步成为万众敬仰的药神。且看他如何用一瓶瓶神药，改变整个世界的格局！',
    genres: ['isekai', 'fantasy', 'action'],
    status: 'ongoing',
    rating: 9.5,
    views: 1670000,
    chapters: [
      { id: 'c6-1', number: 1, title: '穿越异界', date: '2025-01-20' },
      { id: 'c6-2', number: 2, title: '废材体质', date: '2025-01-27' },
      { id: 'c6-3', number: 3, title: '第一瓶药水', date: '2025-02-03' },
      { id: 'c6-4', number: 4, title: '药神初显', date: '2025-02-10' },
      { id: 'c6-5', number: 5, title: '帝都风云', date: '2025-02-17' },
      { id: 'c6-6', number: 6, title: '炼药师大会', date: '2025-02-24' },
      { id: 'c6-7', number: 7, title: '神品丹药', date: '2025-03-03' },
      { id: 'c6-8', number: 8, title: '皇室的秘密', date: '2025-03-10' },
    ],
    updatedAt: '2025-03-10',
  },
  {
    id: '7',
    title: '暗夜追踪',
    author: '权相佑',
    artist: '刘在石',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20crime%20thriller%20comic%20cover%2C%20detective%20in%20trench%20coat%20standing%20in%20rainy%20alley%2C%20noir%20atmosphere%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20dark%20blue%20and%20red%20color%20contrast%2C%20Korean%20webtoon%20art%20style%2C%20suspenseful%20mood%2C%20shadowy%20figure%20in%20background%2C%20cinematic%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '前刑警姜赫因一桩悬案被迫离职，但他从未放弃追查真相。当他发现连环失踪案与十年前的事件有着千丝万缕的联系时，一场危险的追凶之旅开始了。黑暗中，真相远比想象中更加残酷。',
    genres: ['mystery', 'action', 'urban'],
    status: 'ongoing',
    rating: 9.4,
    views: 1030000,
    chapters: [
      { id: 'c7-1', number: 1, title: '离职', date: '2025-03-01' },
      { id: 'c7-2', number: 2, title: '失踪者', date: '2025-03-08' },
      { id: 'c7-3', number: 3, title: '十年前的案子', date: '2025-03-15' },
      { id: 'c7-4', number: 4, title: '暗夜中的线索', date: '2025-03-22' },
      { id: 'c7-5', number: 5, title: '追击', date: '2025-03-29' },
      { id: 'c7-6', number: 6, title: '真相的边缘', date: '2025-04-05' },
    ],
    updatedAt: '2025-04-05',
  },
  {
    id: '8',
    title: '花间秘事',
    author: '柳真',
    artist: '裴秀智',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20comic%20cover%2C%20two%20handsome%20men%20in%20traditional%20Korean%20hanbok%20among%20cherry%20blossoms%2C%20elegant%20historical%20setting%2C%20soft%20pink%20and%20white%20petal%20effects%2C%20romantic%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20delicate%20facial%20expressions%2C%20spring%20garden%20background%2C%20tender%20mood&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '朝鲜时代的宫廷画师李花郎，受命为新入宫的世子绘制肖像。朝夕相处中，两人之间产生了超越君臣的情愫。但宫廷之中暗流涌动，他们的感情能否经受住权力与阴谋的考验？一段隐秘而动人的宫廷之恋。',
    genres: ['bl', 'romance', 'fantasy'],
    status: 'ongoing',
    rating: 9.5,
    views: 1450000,
    chapters: [
      { id: 'c8-1', number: 1, title: '入宫', date: '2025-02-05' },
      { id: 'c8-2', number: 2, title: '画像', date: '2025-02-12' },
      { id: 'c8-3', number: 3, title: '月下的对话', date: '2025-02-19' },
      { id: 'c8-4', number: 4, title: '暗潮', date: '2025-02-26' },
      { id: 'c8-5', number: 5, title: '心之所向', date: '2025-03-05' },
      { id: 'c8-6', number: 6, title: '风波', date: '2025-03-12' },
      { id: 'c8-7', number: 7, title: '守护', date: '2025-03-19' },
    ],
    updatedAt: '2025-03-19',
  },
  {
    id: '9',
    title: '百合花开',
    author: '金荷娜',
    artist: '李多海',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20GL%20romance%20comic%20cover%2C%20two%20beautiful%20women%20in%20flower%20garden%2C%20one%20holding%20the%20other%20hand%20gently%2C%20lily%20flowers%20blooming%20around%20them%2C%20soft%20pastel%20color%20palette%2C%20warm%20sunlight%20filtering%20through%20trees%2C%20Korean%20webtoon%20art%20style%2C%20tender%20and%20peaceful%20atmosphere%2C%20beautiful%20spring%20scenery&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '音乐学院的天才小提琴手郑百合，遇到了钢琴系的冰山美人韩熙妍。两个性格截然不同的女孩，在音乐的牵引下走近彼此。当琴弦与黑白键交织，一段纯美动人的故事在音符中缓缓流淌。',
    genres: ['gl', 'romance', 'campus'],
    status: 'ongoing',
    rating: 9.3,
    views: 920000,
    chapters: [
      { id: 'c9-1', number: 1, title: '初遇', date: '2025-04-10' },
      { id: 'c9-2', number: 2, title: '合奏', date: '2025-04-17' },
      { id: 'c9-3', number: 3, title: '琴声中的秘密', date: '2025-04-24' },
      { id: 'c9-4', number: 4, title: '暴风雨', date: '2025-05-01' },
      { id: 'c9-5', number: 5, title: '和解', date: '2025-05-08' },
    ],
    updatedAt: '2025-05-08',
  },
  {
    id: '10',
    title: '爆笑校园',
    author: '赵仁成',
    artist: '车泰贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20school%20comic%20cover%2C%20funny%20exaggerated%20expressions%20of%20students%20in%20classroom%2C%20colorful%20and%20lively%20composition%2C%20chibi%20style%20characters%2C%20bright%20vibrant%20colors%2C%20Korean%20webtoon%20art%20style%2C%20chaotic%20classroom%20scene%2C%20over%20the%20top%20reactions%2C%20fun%20and%20energetic%20atmosphere&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '一所普通的韩国高中里，住着一群绝对不普通的学生。中二病晚期的班长、整天睡觉却能考第一的学霸、还有那个永远在搞事的体育老师。笑料不断、槽点满满，这部漫画承包你一整年的笑点！',
    genres: ['comedy', 'campus'],
    status: 'ongoing',
    rating: 9.1,
    views: 1980000,
    chapters: [
      { id: 'c10-1', number: 1, title: '开学第一天', date: '2025-01-08' },
      { id: 'c10-2', number: 2, title: '班长的中二病', date: '2025-01-15' },
      { id: 'c10-3', number: 3, title: '睡神的秘密', date: '2025-01-22' },
      { id: 'c10-4', number: 4, title: '体育老师的特训', date: '2025-01-29' },
      { id: 'c10-5', number: 5, title: '食堂大作战', date: '2025-02-05' },
      { id: 'c10-6', number: 6, title: '期末考试灾难', date: '2025-02-12' },
      { id: 'c10-7', number: 7, title: '暑假计划', date: '2025-02-19' },
      { id: 'c10-8', number: 8, title: '修学旅行', date: '2025-02-26' },
    ],
    updatedAt: '2025-02-26',
  },
  {
    id: '11',
    title: '都市夜语',
    author: '吴世勋',
    artist: '边伯贤',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20urban%20drama%20comic%20cover%2C%20stylish%20young%20people%20in%20modern%20Seoul%20cityscape%20at%20night%2C%20city%20lights%20and%20neon%20signs%2C%20contemporary%20fashion%2C%20sophisticated%20mood%2C%20Korean%20webtoon%20art%20style%2C%20rooftop%20scene%20overlooking%20city%2C%20cool%20urban%20vibe%2C%20warm%20street%20lights%20contrasting%20with%20night%20sky&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '四位生活在首尔的年轻人，各自有着不同的梦想和烦恼。白领职员、外卖骑手、实习医生、地下歌手——在这座永不休眠的城市里，他们的命运在不经意间交织在一起。都市的夜晚，总有说不完的故事。',
    genres: ['urban', 'romance', 'comedy'],
    status: 'completed',
    rating: 9.0,
    views: 750000,
    chapters: [
      { id: 'c11-1', number: 1, title: '四人四色', date: '2024-06-01' },
      { id: 'c11-2', number: 2, title: '城市的脉搏', date: '2024-06-08' },
    ],
    updatedAt: '2025-03-30',
  },
  {
    id: '12',
    title: '穿越之皇后驾到',
    author: '沈银河',
    artist: '金泰熙',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20isekai%20historical%20romance%20comic%20cover%2C%20beautiful%20woman%20in%20elegant%20Korean%20traditional%20royal%20hanbok%2C%20palace%20background%20with%20golden%20details%2C%20regal%20and%20majestic%20atmosphere%2C%20warm%20gold%20and%20red%20color%20palette%2C%20Korean%20webtoon%20art%20style%2C%20confident%20expression%2C%20historical%20drama%20aesthetic%2C%20intricate%20fabric%20patterns&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '现代职场女王林小然，在一场车祸中穿越到了古代朝鲜，成为了被冷落的皇后。面对后宫的明争暗斗和朝堂的波诡云谲，她凭借现代人的智慧与手段，从冷宫弃后一步步走向权力巅峰。且看现代女王如何玩转古代后宫！',
    genres: ['isekai', 'romance', 'fantasy'],
    status: 'ongoing',
    rating: 9.6,
    views: 2340000,
    chapters: [
      { id: 'c12-1', number: 1, title: '车祸', date: '2025-01-10' },
      { id: 'c12-2', number: 2, title: '冷宫皇后', date: '2025-01-17' },
      { id: 'c12-3', number: 3, title: '第一次反击', date: '2025-01-24' },
      { id: 'c12-4', number: 4, title: '朝堂风云', date: '2025-01-31' },
      { id: 'c12-5', number: 5, title: '后宫联盟', date: '2025-02-07' },
      { id: 'c12-6', number: 6, title: '阴谋的序幕', date: '2025-02-14' },
      { id: 'c12-7', number: 7, title: '王的心', date: '2025-02-21' },
      { id: 'c12-8', number: 8, title: '决战之夜', date: '2025-02-28' },
      { id: 'c12-9', number: 9, title: '新格局', date: '2025-03-07' },
    ],
    updatedAt: '2025-03-07',
  },
  {
    id: '13',
    title: '幽灵侦探社',
    author: '张根硕',
    artist: '李敏镐',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20mystery%20comic%20cover%2C%20young%20detective%20with%20ghost%20companion%20in%20old%20office%2C%20vintage%20detective%20agency%20setting%2C%20spooky%20but%20not%20scary%20atmosphere%2C%20warm%20sepia%20and%20teal%20color%20contrast%2C%20Korean%20webtoon%20art%20style%2C%20mysterious%20objects%20floating%2C%20cozy%20supernatural%20vibe%2C%20film%20noir%20elements&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    description: '能看见鬼魂的大学生金智勋，阴差阳错地继承了一家侦探社。更离谱的是，他的助手是一群各怀绝技的幽灵。从此，一人三鬼的奇葩组合，开始接手各种离奇案件。悬疑中带着搞笑，恐怖中透着温馨！',
    genres: ['mystery', 'comedy', 'urban'],
    status: 'ongoing',
    rating: 9.2,
    views: 1120000,
    chapters: [
      { id: 'c13-1', number: 1, title: '继承侦探社', date: '2025-03-20' },
      { id: 'c13-2', number: 2, title: '幽灵助手', date: '2025-03-27' },
      { id: 'c13-3', number: 3, title: '第一个案件', date: '2025-04-03' },
      { id: 'c13-4', number: 4, title: '校园怪谈', date: '2025-04-10' },
      { id: 'c13-5', number: 5, title: '消失的证人', date: '2025-04-17' },
      { id: 'c13-6', number: 6, title: '暗处的敌人', date: '2025-04-24' },
    ],
    updatedAt: '2025-04-24',
  },
  {
    id: '14',
    title: '拳王之路',
    author: '马东锡',
    artist: '金钟国',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sports%20action%20comic%20cover%2C%20boxer%20in%20ring%20with%20determined%20expression%2C%20dramatic%20spotlight%20effect%2C%20sweat%20and%20motion%20effects%2C%20intense%20fighting%20spirit%2C%20dark%20arena%20background%2C%20Korean%20webtoon%20art%20style%2C%20athletic%20physique%2C%20powerful%20composition%2C%20warm%20golden%20spotlight%20contrasting%20with%20darkness&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    description: '街头混混朴泰成，为了给病重的母亲筹集医药费，走上了地下拳台。从最初的为了钱而战，到后来真正爱上这项运动。面对强大的对手和黑暗的势力，他将用拳头打出属于自己的荣耀之路！',
    genres: ['action', 'urban'],
    status: 'ongoing',
    rating: 9.3,
    views: 1560000,
    chapters: [
      { id: 'c14-1', number: 1, title: '走投无路', date: '2025-02-15' },
      { id: 'c14-2', number: 2, title: '地下拳台', date: '2025-02-22' },
      { id: 'c14-3', number: 3, title: '初战告捷', date: '2025-03-01' },
      { id: 'c14-4', number: 4, title: '强敌来袭', date: '2025-03-08' },
      { id: 'c14-5', number: 5, title: '败北', date: '2025-03-15' },
      { id: 'c14-6', number: 6, title: '重新站起', date: '2025-03-22' },
      { id: 'c14-7', number: 7, title: '复仇之战', date: '2025-03-29' },
    ],
    updatedAt: '2025-03-29',
  },
  {
    id: '15',
    title: '魔法学院优等生',
    author: '林允儿',
    artist: '郑秀晶',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20academy%20fantasy%20comic%20cover%2C%20students%20in%20magical%20school%20uniforms%20casting%20spells%2C%20floating%20magic%20books%20and%20crystals%2C%20grand%20academy%20hall%20background%2C%20vibrant%20magical%20effects%20in%20pastel%20colors%2C%20Korean%20webtoon%20art%20style%2C%20whimsical%20atmosphere%2C%20detailed%20magical%20accessories%2C%20warm%20and%20inviting%20mood&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    description: '在魔法至上的世界里，出身平民的天才少女尹瑞娜，凭借惊人的天赋考入了贵族云集的帝国魔法学院。在这里，她不仅要面对繁重的学业，还要应对来自贵族学生的排挤和歧视。但她的目标是——成为学院史上最年轻的传奇魔法师！',
    genres: ['fantasy', 'campus', 'action'],
    status: 'ongoing',
    rating: 9.4,
    views: 1870000,
    chapters: [
      { id: 'c15-1', number: 1, title: '入学通知书', date: '2025-02-20' },
      { id: 'c15-2', number: 2, title: '魔法测试', date: '2025-02-27' },
      { id: 'c15-3', number: 3, title: '贵族与平民', date: '2025-03-06' },
      { id: 'c15-4', number: 4, title: '第一次实战', date: '2025-03-13' },
      { id: 'c15-5', number: 5, title: '隐藏的才能', date: '2025-03-20' },
      { id: 'c15-6', number: 6, title: '学院大赛', date: '2025-03-27' },
      { id: 'c15-7', number: 7, title: '黑暗的预兆', date: '2025-04-03' },
    ],
    updatedAt: '2025-04-03',
  },
];